import React, { useState, useEffect } from "react"
import { nanoid } from "nanoid"

function Equipment({ equipment }) {
    const [ filtered, setFiltered ] = useState([])

    useEffect(() => {
        const getFiltered = () => {
            const arr = []
            equipment.forEach( item => {
                item.forEach( content => {
                    arr.push(content)
                })
            })
    
            const unique = [...new Map(arr.map(item => [item.id, item])).values()]
            setFiltered( unique )
        }
        getFiltered()
    }, [equipment, setFiltered])

    return (
        <section className="container">
            {
                filtered.map( item => {
                    return  <div key={nanoid()} className="tile equipmentTile">
                        <img 
                            className="equipmentImg"
                            src={`https://spoonacular.com/cdn/equipment_500x500/${item.image}`} 
                            alt="Equipment" />
                        <p>{item.name}</p>
                    </div>
                })
            }
        </section>
    )
}

export default Equipment
